import {
  ADA_SEND_START,
  ADA_SEND_SUCCESS,
  ADA_SEND_ERROR,
  ADA_SEND_RESET,
} from "../actions/ada";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: "",
    },
  },
};

export function adaSend(state = defaultState, { type, payload, error }) {
  switch (type) {
    case ADA_SEND_START:
      return {
        status: {
          started: true,
          error: false,
          ended: false,
        },
      };
    case ADA_SEND_SUCCESS:
      return {
        status: {
          started: false,
          error: false,
          ended: true,
        },
      };
    case ADA_SEND_ERROR:
      return {
        status: {
          started: false,
          error: true,
          ended: false,
          errorInfo: { message: error },
        },
      };
    case ADA_SEND_RESET:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
}
